import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {CommonModule} from '@angular/common';
import {OphButtonModule} from '../../../design/oph-button/oph-button.module';
import {ListViewsModule} from '../../../list-views/list-views.module';

@Component({
  selector: 'projects-task-default-footer',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, OphButtonModule, ListViewsModule],
  templateUrl: './projects-task-default-footer.component.html',
  styleUrl: './projects-task-default-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskDefaultFooterComponent {
  @Input() loading = false;
  @Input() hideMenu = false;
  @Input() isTemplate = false;

  @Output() cancel = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() duplicate = new EventEmitter<void>();
  @Output() createTemplate = new EventEmitter<void>();

  menuOptions = ['create template', 'duplicate', 'delete'];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isTemplate'] && changes['isTemplate'].currentValue !== undefined) {
      this.menuOptions = this.isTemplate ? ['delete'] : ['create template', 'duplicate', 'delete'];
    }
  }

  onMenu(type: string): void {
    switch (type) {
      case 'delete':
        this.delete.emit();
        break;
      case 'create template':
        this.createTemplate.emit();
        break;
      case 'duplicate':
        this.duplicate.emit();
        break;
    }
  }
}
